import { render } from "./ScanTablet.vue?vue&type=template&id=c2d15fb0"
import script from "./ScanTablet.vue?vue&type=script&lang=ts"
export * from "./ScanTablet.vue?vue&type=script&lang=ts"

import "./ScanTablet.vue?vue&type=style&index=0&id=c2d15fb0&lang=scss"
script.render = render

export default script